import { HTMLAttributes, useId, useRef } from 'react';
import { Tooltip } from 'primereact/tooltip';
import { LongTextTooltip } from './long-text-tooltip';

/** Formatted, focusable alternative to the browser's plain-text title tooltip. */
export function MarkdownHint({ content, children, ...props }: Omit<HTMLAttributes<HTMLSpanElement>, 'content'> & { content?: string | null }) {
    const id = `markdown-hint-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
    const tooltip = useRef<Tooltip>(null);
    return <span {...props} id={id} tabIndex={content ? 0 : undefined} onKeyDown={event => {
        if (event.key === 'Escape') tooltip.current?.hide();
        props.onKeyDown?.(event);
    }}>
        {children}
        {content && <LongTextTooltip ref={tooltip} target={`#${id}`} content={content} />}
    </span>;
}
